<template>
  <div class="part-detail-bd tb" v-if="funcView.part_replace_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-radio-group v-model="formSearch.partClass" @change="onPageChange({ page: 1 })">
          <el-radio-button label="">{{ $t('Common.com_all') }}</el-radio-button>
          <el-radio-button :label="item.value" v-for="(item, index) in propertyMap.asm_part_class" :key="index">{{ item.name }}</el-radio-button>
        </el-radio-group>
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
           <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- 导出 -->
        <el-form-item style="float: right; " v-if="funcView.part_replace_export">
          <el-button class="table-set" style="vertical-align: top;" @click="exportTable('workOrderPartExport', formSearch)">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input :placeholder="$t('asm_part_detail.ljbhljmcjshghr')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
     <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter('keyword')">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('asm_part_detail.gong_dan_bian_hao')">
          <el-input v-model="formSearch.workOrderCode" ></el-input>
        </el-form-item>
        <el-form-item :label="$t('asm_part_detail.jiu_ling_jianSN')">
          <el-input v-model="formSearch.oldPartSn"></el-input>
        </el-form-item>
        <el-form-item :label="$t('asm_part_detail.xin_ling_jianSN')">
          <el-input v-model="formSearch.partSn"></el-input>
        </el-form-item>
        <!-- partnerSelectOrgan  childOrgType: 'CO' // 总部 HQ 售后公司SC 总代理 JV 大客户CO 租赁方CS -->
        <el-form-item :label="$t('asm_part_detail.geng_huan_shi_jian')">
          <custom-date-picker
            v-model="formSearch.changeTime"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="pickerOptionDisAfter"
            style="width: 100%"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('asm_part_detail.chan_pin_xing_hao')">
          <custom-select
            url="productCodeSelectList"
            v-model="formSearch.productCode"
            :props="{ label: 'productCode', value: 'productCode' }"
            :placeholder="$t('Common.com_please_select')"
            width="100%"
          ></custom-select>
        </el-form-item>
        <el-form-item :label="$t('asm_part_detail.dai_li_gong_si')">
          <el-input v-model="formSearch.agentCoName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('asm_part_detail.zu_lin_fang')">
          <el-input v-model="formSearch.customerName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('asm_part_detail.xiang_mu')">
          <el-input v-model="formSearch.locationName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('asm_part_detail.shou_hou_gong_si')">
          <el-input v-model="formSearch.afterServiceName"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table height="100%" :index="true" :data="tableList" :column="tableColumn" @sort="sortChange" @filter="filterChange" :slots="['bodyNum','workOrderCode','action']">
        <template
          slot="bodyNum"
          slot-scope="scope"
        >
          <div
            v-if="funcView.part_replace_device_detail"
            class="cell-link"
            @click="jump('/devicedetail', { deviceId: scope.row.deviceId, parentPath: $route.path })"
          >{{ scope.row.bodyNum }}</div>
          <span v-else>{{ scope.row.bodyNum }}</span>
        </template>
        <template
          slot="workOrderCode"
          slot-scope="scope"
        >
          <div
            v-if="funcView.part_replace_order_detail"
            class="cell-link"
            @click="jump('/workorder/workOrderDetail', { orderType: 'workOrder',caseOrderType:  scope.row.workOrderType,workOrderId:  scope.row.workOrderId,parentPath: $route.path })"
          >{{ scope.row.workOrderCode }}</div>
          <span v-else>{{ scope.row.workOrderCode }}</span>
        </template>
        <template slot="action" slot-scope="scope">
          <el-button type="text" size="mini" @click="detailEvent(scope.row)" v-if="funcView.part_replace_view">{{funcView.part_replace_view}}</el-button>
          <el-button type="text" size="mini" @click="detailResume(scope.row)" v-if="funcView.part_replace_history">{{funcView.part_replace_history}}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>

    <part-change-dialog
      v-if="dialogVisible"
      :model="dialogModel"
      @close="dialogVisible = false"
      @success="getTableList()"
    ></part-change-dialog>
    <part-resume-dialog
      v-if="dialogVisible1"
      :model="dialogModel1"
      @close="dialogVisible1 = false"
    ></part-resume-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';
import moment from 'moment';
import partChangeDialog from './children/part_change_dialog.vue';
import partResumeDialog from './children/part_resume_dialog.vue';

export default {
  name: 'partDetail',
  mixins: [resetFormSearchMixins],
  components: { partChangeDialog, partResumeDialog },
  data() {
    return {
      provide: true,
      tableCode: 'part_detail',
      formSearch: {
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 20,
        pageNum: 1,
        partClass: '',
        productCode: '',
        changeTime: [],
        replaceTimeStart: '',
        replaceTimeEnd: '',
        agentCoName: '',
        customerName: '',
        locationName: '',
        afterServiceName: '',
      },
      dataTimes: [],
      tableList: [],
      totalRows: null,

      dialogVisible: false,
      dialogModel: {},
      dialogVisible1: false,
      dialogModel1: {},
      link: null,
    };
  },
  mounted: function () {
    this.formSearch.changeTime = [this.$momentWorld(moment().startOf('month')), this.$momentWorld(moment().endOf('day'))];
    this.resetForm = JSON.stringify(this.form);
    this.resetFormSearch = JSON.stringify(this.formSearch);
    // 消息类型
    this.getDictionary('asm_part_class');
    this.getTableColumn();
    this.getTableList();
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });
  },
  methods: {
    // 获取表格数据列表
    getTableList: function () {
      this.formSearch.replaceTimeStart = this.formSearch.changeTime && this.formSearch.changeTime[0] ? this.formSearch.changeTime[0] : '';
      this.formSearch.replaceTimeEnd = this.formSearch.changeTime && this.formSearch.changeTime[1] ? this.formSearch.changeTime[1] : '';
      this.$getJSON(apis.workOrderPartPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 更换明细
    detailEvent: function (data) {
      this.dialogModel.type = 'detail';
      this.dialogModel.title = this.$t('asm_part_detail.ljghmx');
      this.dialogModel.row = data;
      this.dialogVisible = true;
    },
    //
    detailResume: function (data) {
      this.dialogModel1.type = 'detail';
      this.dialogModel1.title = this.$t('asm_part_detail.she_bei_lv_li_biao');
      this.dialogModel1.row = data;
      this.dialogVisible1 = true;
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  }
};
</script>

<style lang='scss'>
@import "@/style/colors.scss";
.part-detail-bd {
}
</style>
